import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_PAYMENT_RECEIVED_LIST: string = typeCreatorV2(
  'PaymentsReceivedListReducer',
  'SetPaymentsReceivedList'
);

export const SET_MEMBER_STATE: string = typeCreatorV2(
  'PaymentsReceivedListReducer',
  'SetMemberStateCountries'
);

export const SET_UNREAD_NOTIFICATION_COUNT: string = typeCreatorV2(
  'PaymentsReceivedListReducer',
  'SetUnreadNotificationCount'
);

export const SET_MEMBER_STATE_EXCLUDE_CYPRUS: string = typeCreatorV2(
  'PaymentsReceivedListReducer',
  'SetMemberStateCountriesExcludeCyprus'
);

export const SET_ALLOCATE_PAYMENT_RECEIVED: string = typeCreatorV2(
  'AllocatePaymentReceivedReducer',
  'SetAllocatePaymentReceived'
);
